import { render, staticRenderFns } from "./FileAttribute.vue?vue&type=template&id=1f00671c&scoped=true&"
import script from "./FileAttribute.vue?vue&type=script&lang=js&"
export * from "./FileAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00671c",
  null
  
)

export default component.exports